import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../logo.png';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <Link to="/" className="logo">
          <img src={logoImg} alt="Ultraze FA Logo" className="logo-img" />
          <h1>ULTRAZE <span className="highlight">FA</span></h1>
        </Link>
        <nav className="nav">
          <Link to="/" className="nav-link">Accueil</Link>
          <Link to="/histoire" className="nav-link">Histoire</Link>
          <Link to="/avenir" className="nav-link">Avenir</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;